module.exports = __webpack_public_path__ + "img/trial3-4.2288d897.png";